import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import type { CustomersFeedbackApiParameters } from "../../components/screens/reports/customers/customersFeedback/selectors"
import { request } from "../../utils/http"

export type GetCustomersFeedbackReportServerResponse = {
    content: CustomersFeedbackReportResponseItem[]
    total_count: number
    page_size: number
    offset: number
}

export type CustomersFeedbackReportResponseItem = {
    feedback_id: string
    order_id: string
    feedback_timestamp: string
    customer_name: string
    customer_id: string
    order_number: string
    feedback: string
    comment: string
}

export const getCustomersFeedbackReportApi = (
    headers: Record<string, any>,
    config: CustomersFeedbackApiParameters
): Rx.Observable<GetCustomersFeedbackReportServerResponse> =>
    Rx.defer(() =>
        request({
            method: "GET",
            parameters: config,
            path: "/report/customer-feedback",
            headers: headers,
        })
    ).pipe(retry(3))
